module.exports = __webpack_public_path__ + "assets/img/dy_logo.05b2e6f5.png";